import { createEnv } from "@t3-oss/env-core";
import { z } from "zod";

export const env = createEnv({
  clientPrefix: "VITE_",

  client: {
    VITE_SUPABASE_URL: z.string().url(),
    VITE_SUPABASE_ANON_KEY: z.string(),
    VITE_API_URL: z.string().url(),
    VITE_BRANCH: z.string(),
    VITE_POSTHOG_KEY: z.string(),
    VITE_POSTHOG_HOST: z.string(),
    VITE_SENTRY_DSN: z.string(),
  },

  /**
   * What object holds the environment variables at runtime. This is usually
   * `process.env` or `import.meta.env`.
   */
  runtimeEnv: import.meta.env,

  emptyStringAsUndefined: true,
});
